var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":_vm.wpLink,"target":"_blank"}},[(!_vm.arabic)?_c('img',{attrs:{"src":require("../../assets/images/LogoLight.svg"),"alt":"Ayadi"}}):_c('img',{attrs:{"src":require("../../assets/images/LogoLightArabic.svg"),"alt":"Ayadi","width":"150px"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }